import request from '@/core/http/request'

const BASE = '/qingguang/cooperativesupplier'

// ---------------------------------------------------------------------------
// 1. 产品委外收料（ERP：产品委外发料单）
// ---------------------------------------------------------------------------

/** 提交收料确认 */
export function outsorRequisitionDoc_confirmReceive(data) {
  return request({
    url: `${BASE}/outsorRequisitionDoc/confirmReceive`,
    method: 'post',
    data: data
  })
}

/** 撤销收料确认 */
export function outsorRequisitionDoc_cancelReceiveConfirm(data) {
  return request({
    url: `${BASE}/outsorRequisitionDoc/cancelReceiveConfirm`,
    method: 'post',
    data: data
  })
}

/** 发料单详情 */
export function outsorRequisitionDoc_view(data) {
  return request({
    url: `${BASE}/outsorRequisitionDoc/view`,
    method: 'get',
    params: data
  })
}

/** 发料单列表 */
export function outsorRequisitionDoc_listTwo(data) {
  return request({
    url: `${BASE}/outsorRequisitionDoc/listTwo`,
    method: 'post',
    data: data
  })
}

// ---------------------------------------------------------------------------
// 2. 工序委外收料（ERP：工序委外发料单）
// ---------------------------------------------------------------------------

/** 工序发料单列表（含明细） */
export function processOutsourcingRequisitionDoc_listWithDetail(data) {
  return request({
    url: `${BASE}/processOutsourcingRequisitionDoc/listWithDetail`,
    method: 'post',
    data: data
  })
}

/** 工序委外收料详情 */
export function processOutsourcingRequisitionDoc_view(data) {
  return request({
    url: `${BASE}/processOutsourcingRequisitionDoc/view`,
    method: 'get',
    params: data
  })
}

/** 预加载工序委外收料确认 */
export function processOutsourcingRequisitionDoc_preloadForReceiveConfirm(data) {
  return request({
    url: `${BASE}/processOutsourcingRequisitionDoc/preloadForReceiveConfirm`,
    method: 'post',
    data: data
  })
}

/** 提交工序委外收料确认 */
export function processOutsourcingRequisitionDoc_confirmReceive(data) {
  return request({
    url: `${BASE}/processOutsourcingRequisitionDoc/confirmReceive`,
    method: 'post',
    data: data
  })
}

/** 撤销工序委外收料确认 */
export function processOutsourcingRequisitionDoc_cancelReceiveConfirm(data) {
  return request({
    url: `${BASE}/processOutsourcingRequisitionDoc/cancelReceiveConfirm`,
    method: 'post',
    data: data
  })
}

/** 回补工序收料协同库存（已收料但库存未展示时） */
export function processOutsourcingRequisitionDoc_syncReceiveInventory(data) {
  return request({
    url: `${BASE}/processOutsourcingRequisitionDoc/syncReceiveInventory`,
    method: 'post',
    data: data
  })
}

// ---------------------------------------------------------------------------
// 3. 产品委外出货（ERP：产品委外收货单）
// ---------------------------------------------------------------------------

/** 保存出货草稿 */
export function outsourcingtowarehouse_saveDraft(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/saveDraft`,
    method: 'post',
    data: data
  })
}

/** 出货单列表 */
export function outsourcingtowarehouse_getVagueList(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/getVagueList`,
    method: 'post',
    data: data
  })
}

/** 出货统计 */
export function outsourcingtowarehouse_getDeliveryStat(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/getDeliveryStat`,
    method: 'post',
    data: data
  })
}

/** 产品委外发货详情 */
export function outsourcingtowarehouse_view(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/view`,
    method: 'get',
    params: data
  })
}

/** 新增出货单 */
export function outsourcingtowarehouse_add(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/add`,
    method: 'post',
    data: data
  })
}

/** 修改出货单 */
export function outsourcingtowarehouse_update(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/update`,
    method: 'post',
    data: data
  })
}

/** 提交出货草稿 */
export function outsourcingtowarehouse_submitDraft(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/submitDraft`,
    method: 'post',
    data: data
  })
}

/** 按 globalId 审核/取消审核（type: 1审核 2取消审核） */
export function outsourcingtowarehouse_auditByGlobal(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/auditByGlobal`,
    method: 'post',
    data: data
  })
}

/** 出库（status_outwarehouse → 1） */
export function outsourcingtowarehouse_outWarehouse(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/outWarehouse`,
    method: 'post',
    data: data
  })
}

/** 撤销出库（status_outwarehouse → 0） */
export function outsourcingtowarehouse_cancellationOutWarehouse(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/cancellationOutWarehouse`,
    method: 'post',
    data: data
  })
}

/** 删除出货单 */
export function outsourcingtowarehouse_delete(data) {
  return request({
    url: `${BASE}/outsourcingtowarehouse/delete`,
    method: 'post',
    data: data
  })
}

// ---------------------------------------------------------------------------
// 4. 工序委外发货（协同表 t_srm_coop_process_delivery）
// ---------------------------------------------------------------------------

/** 新建工序发货单 */
export function processCoopDelivery_add(data) {
  return request({
    url: `${BASE}/processCoopDelivery/add`,
    method: 'post',
    data: data
  })
}

/** 保存工序发货草稿 */
export function processCoopDelivery_saveDraft(data) {
  return request({
    url: `${BASE}/processCoopDelivery/saveDraft`,
    method: 'post',
    data: data
  })
}

/** 工序发货草稿转新建 */
export function processCoopDelivery_submitDraft(data) {
  return request({
    url: `${BASE}/processCoopDelivery/submitDraft`,
    method: 'post',
    data: data
  })
}

/** 工序发货列表 */
export function processCoopDelivery_list(data) {
  return request({
    url: `${BASE}/processCoopDelivery/list`,
    method: 'post',
    data: data
  })
}

/** 工序发货详情 */
export function processCoopDelivery_view(data) {
  return request({
    url: `${BASE}/processCoopDelivery/view`,
    method: 'get',
    params: data
  })
}

/** 审核/反审核工序发货（type: 1审核 2反审核） */
export function processCoopDelivery_auditByGlobal(data) {
  return request({
    url: `${BASE}/processCoopDelivery/auditByGlobal`,
    method: 'post',
    data: data
  })
}

/** 工序发货出库 */
export function processCoopDelivery_outWarehouse(data) {
  return request({
    url: `${BASE}/processCoopDelivery/outWarehouse`,
    method: 'post',
    data: data
  })
}

/** 撤销工序发货出库 */
export function processCoopDelivery_cancellationOutWarehouse(data) {
  return request({
    url: `${BASE}/processCoopDelivery/cancellationOutWarehouse`,
    method: 'post',
    data: data
  })
}

/** 工序委外可发货信息（预填） */
export function processOutsourcingReceive_processOutsourcingCanReceiveProduction(data) {
  return request({
    url: `${BASE}/processOutsourcingReceive/processOutsourcingCanReceiveProduction`,
    method: 'post',
    data: data
  })
}

// ---------------------------------------------------------------------------
// 5. 协同库存仓（产品+工序同表；bizDocKind 空=全部）
// ---------------------------------------------------------------------------

/** 协同库存结存列表 */
export function outsourcingWarehouse_list(data) {
  return request({
    url: `${BASE}/outsourcingWarehouse/list`,
    method: 'post',
    data: data
  })
}

/** 协同库存看板统计 */
export function outsourcingWarehouse_getInventoryStat(data) {
  return request({
    url: `${BASE}/outsourcingWarehouse/getInventoryStat`,
    method: 'post',
    data: data
  })
}

/** 按物料+规格汇总（数量降序） */
export function outsourcingWarehouse_listMaterialSummary(data) {
  return request({
    url: `${BASE}/outsourcingWarehouse/listMaterialSummary`,
    method: 'post',
    data: data
  })
}

/** 按委外单查询协同库存结存 */
export function outsourcingWarehouse_listByOutsourcingDocId(data) {
  return request({
    url: `${BASE}/outsourcingWarehouse/listByOutsourcingDocId`,
    method: 'post',
    data: data
  })
}

/** 协同委外库存详情 */
export function outsourcingWarehouse_view(data) {
  return request({
    url: `${BASE}/outsourcingWarehouse/view`,
    method: 'get',
    params: data
  })
}

/** 协同委外库存流水 */
export function outsourcingWarehouse_flowList(data) {
  return request({
    url: `${BASE}/outsourcingWarehouse/flowList`,
    method: 'post',
    data: data
  })
}

/** 有批次库存台账（批次+物料+规格+委外订单） */
export function outsourcingWarehouse_listBatchInventory(data) {
  return request({
    url: `${BASE}/outsourcingWarehouse/listBatchInventory`,
    method: 'post',
    data: data
  })
}

// ---------------------------------------------------------------------------
// 6. 委外订单
// ---------------------------------------------------------------------------

/** 产品委外订单列表 */
export function outsourcingDoc_vagueList(data) {
  return request({
    url: `${BASE}/outsourcingDoc/vagueList`,
    method: 'post',
    data: data
  })
}

/** 产品委外详情 */
export function outsourcingDoc_view(data) {
  return request({
    url: `${BASE}/outsourcingDoc/view`,
    method: 'get',
    params: data
  })
}

/** 可退料数据 */
export function outsourcingDoc_getOutsourcingDoc(data) {
  return request({
    url: `${BASE}/outsourcingDoc/getOutsourcingDoc`,
    method: 'post',
    data: data
  })
}

/** 工序委外订单列表 */
export function processOutsourcing_list(data) {
  return request({
    url: `${BASE}/processOutsourcing/list`,
    method: 'post',
    data: data
  })
}

/** 工序委外订单详情 */
export function processOutsourcing_view(data) {
  return request({
    url: `${BASE}/processOutsourcing/view`,
    method: 'get',
    params: data
  })
}

// ---------------------------------------------------------------------------
// 7. 产品委外退料
// ---------------------------------------------------------------------------

/** 查询产品委外退料 */
export function outsorReturnDoc_outsorReturnDocList(data) {
  return request({
    url: `${BASE}/outsorReturnDoc/outsorReturnDocList`,
    method: 'post',
    data: data
  })
}

/** 产品委外退料新增 */
export function outsorReturnDoc_add(data) {
  return request({
    url: `${BASE}/outsorReturnDoc/add`,
    method: 'post',
    data: data
  })
}

/** 产品委外退料详情 */
export function outsorReturnDoc_view(data) {
  return request({
    url: `${BASE}/outsorReturnDoc/view`,
    method: 'get',
    params: data
  })
}

/** 产品委外退料修改 */
export function outsorReturnDoc_update(data) {
  return request({
    url: `${BASE}/outsorReturnDoc/update`,
    method: 'post',
    data: data
  })
}

// ---------------------------------------------------------------------------
// 8. 工序委外退料
// ---------------------------------------------------------------------------

/** 工序委外退料列表 */
export function processOutsourcingReturn_listWithMaterial(data) {
  return request({
    url: `${BASE}/processOutsourcingReturn/listWithMaterial`,
    method: 'post',
    data: data
  })
}

/** 工序委外退料详情 */
export function processOutsourcingReturn_view(data) {
  return request({
    url: `${BASE}/processOutsourcingReturn/view`,
    method: 'get',
    params: data
  })
}

// ---------------------------------------------------------------------------
// 9. 委外对账单（产品 modelType=1 / 工序 modelType=2）
// ---------------------------------------------------------------------------

/** 协同委外对账单列表（已审核） */
export function pmgtPurchasesStatementDoc_getCooperativeSupplierPurchaseStatementDocList(
  data
) {
  return request({
    url: `${BASE}/pmgtPurchasesStatementDoc/getCooperativeSupplierPurchaseStatementDocList`,
    method: 'post',
    data: data
  })
}

/** 协同委外对账单详情 */
export function pmgtPurchasesStatementDoc_getCooperativeSupplierPurchaseStatementDocView(
  data
) {
  return request({
    url: `${BASE}/pmgtPurchasesStatementDoc/getCooperativeSupplierPurchaseStatementDocView`,
    method: 'post',
    data: data
  })
}

/** 确认对账单 */
export function pmgtPurchasesStatementDoc_confirmStatement(data) {
  return request({
    url: `${BASE}/pmgtPurchasesStatementDoc/confirmStatement`,
    method: 'post',
    data: data
  })
}

/** 提出异议 */
export function pmgtPurchasesStatementDoc_objectStatement(data) {
  return request({
    url: `${BASE}/pmgtPurchasesStatementDoc/objectStatement`,
    method: 'post',
    data: data
  })
}

/** 撤销确认/异议 */
export function pmgtPurchasesStatementDoc_cancelConfirm(data) {
  return request({
    url: `${BASE}/pmgtPurchasesStatementDoc/cancelConfirm`,
    method: 'post',
    data: data
  })
}

// ---------------------------------------------------------------------------
// 10. 协同工作台
// ---------------------------------------------------------------------------

/** 首页待办统计 */
export function cooperativeDashboard_getHomeStat(data) {
  return request({
    url: `${BASE}/cooperativeDashboard/getHomeStat`,
    method: 'post',
    data: data || {}
  })
}

/** 首页协同提醒看板 */
export function cooperativeDashboard_getReminderBoard(data) {
  return request({
    url: `${BASE}/cooperativeDashboard/getReminderBoard`,
    method: 'post',
    data: data || {}
  })
}

/** 首页今日待办列表 */
export function cooperativeDashboard_listTodo(data) {
  return request({
    url: `${BASE}/cooperativeDashboard/listTodo`,
    method: 'post',
    data: data || {}
  })
}

/** 产品委外订单批量详情（组打印） */
export function outsourcingDoc_vagueOutsourcingDocListByIds(data) {
  return request({
    url: `${BASE}/outsourcingDoc/vagueOutsourcingDocListByIds`,
    method: 'post',
    data: data
  })
}

/** 工序委外订单批量详情（组打印） */
export function selectProcessOutsourcingByIds(data) {
  return request({
    url: `${BASE}/processOutsourcing/selectProcessOutsourcingByIds`,
    method: 'post',
    data: data
  })
}

/** 工序委外发料批量详情（组打印） */
export function selectProcessOutsourcingRequisitionDocByIds(data) {
  return request({
    url: `${BASE}/processOutsourcingRequisitionDoc/selectProcessOutsourcingRequisitionDocByIds`,
    method: 'post',
    data: data
  })
}
